const HackerNewsLogo = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 32 32'
    width={32}
    height={32}
    {...props}
  >
    <path
      fill='#F60'
      fillRule='evenodd'
      d='M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm4 9 5.013 9.052V24h1.928v-5.838L22 9h-2.132l-2.995 5.729c-.15.306-.298.601-.442.885-.144.285-.276.55-.397.799a10.114 10.114 0 0 0-.159-.383 7.115 7.115 0 0 0-.204-.427 1.296 1.296 0 0 1-.045-.098.668.668 0 0 0-.068-.12 2.787 2.787 0 0 0-.16-.34 4.059 4.059 0 0 1-.158-.316L12.291 9H10z'
      clipRule='evenodd'
    />
  </svg>
)

export default HackerNewsLogo
